// extracted by mini-css-extract-plugin
export default {"tupacGrid":"pn-z","tupacHeader":"qn-z","tupacHeader2":"rn-z","tupacMenu":"sn-z","tupacMenu2":"tn-z","tupacMain":"un-z","tupacMain2":"vn-z"};